
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import InfoAssetBanner from '@/components/base/InfoAssetBanner.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { db } from '@/firebase';
import { NSFW_THRESHOLD, NsfwThreshold } from '@run-diffusion/shared';
import EnterpriseUpsellWrapper from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellWrapper.vue';

export default Vue.extend({
	name: 'TeamRunnitSettings',
	props: {
		currTeam: { type: Object, default: null },
	},
	data () {
		return {
			nsfwThresholdOptions: [
				{
					text: 'Maximum Safety',
					value: NSFW_THRESHOLD.SFW_2,
					subheader: 'Most likely to block generations that aren\'t NSFW',
				},
				{
					text: 'Block More',
					value: NSFW_THRESHOLD.SFW_1,
					subheader: 'More likely to block generations that aren\'t NSFW',
				},
				{
					text: 'Default',
					value: null,
				},
				{
					text: 'Block Less',
					value: NSFW_THRESHOLD.NSFW_1,
					subheader: 'More likely to allow NSFW generations',
				},
				{
					text: 'Block Least',
					value: NSFW_THRESHOLD.NSFW_2,
					subheader: 'Most likely to allow NSFW generations',
				},
			],
			nsfwThresholdSaving: false,
		};
	},
	computed: {
		...mapGetters([
			'companyClubOfferBenefits',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
			'setUpsellDialog',
		]),
		onEnterpriseNsfwUpsell () {
			this.setUpsellDialog({ noEnterpriseNsfwSettings: true });
		},
		async setNsfwThreshold (nsfwThreshold: NsfwThreshold) {
			if (this.nsfwThresholdSaving) return;
			this.nsfwThresholdSaving = true;

			try {
				await db.doc(`teams/${this.currTeam.id}`).update({
					nsfwThreshold,
				});

				this.updateSnackbar({
					status: SNACKBAR_STATUS.SUCCESS,
					message: 'NSFW threshold updated successfully',
					show: true,
				});
			} catch (e) {
				console.error('Error updating NSFW threshold:', e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Failed to update NSFW threshold',
					show: true,
				});
			} finally {
				this.nsfwThresholdSaving = false;
			}
		},
	},
	components: {
		EnterpriseUpsellWrapper,
		InfoAssetBanner,
	},
});
